<template>
  <div class="team">
    <div class="tway-title-hero"></div>
    <div class="intro-platform">
      <v-container>
        <v-row>
          <v-col xs="12" sm="12" md="5" lg="5">
            <div
              :class="mobile ? 'text-center' : ''"
              class="tway-headline-2 tway-morado--text"
            >
              Diagnostica, Activa, Acelera, Acompaña y Mide la Transformación en
              tu Empresa
            </div>
            <div class="platform-subtitle-no-mobile">
              <div
                class="tway-headline-extra-info grey--text text--darken-3 mt-3"
              >
                22,5% es lo que representa la economía digital en el PIB de
                Chile
              </div>
              <div class="tway-body grey--text mt-3">
                Fuente: Estudio Accenture Oxford Economics 2018
              </div>
              <div
                :class="mobile ? 'justify-center' : 'justify-start'"
                class="d-flex btn-subscribe-container"
              >
                <v-btn
                  rounded
                  color="tway-verde-manzana"
                  class="white--text font-weight-bold mt-5"
                  :href="config.login"
                  x-large
                >
                  Inicia sesión
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col xs="12" sm="12" md="7" lg="7">
            <v-img
              :src="require('@/assets/images/macbook-platform-tway.jpeg')"
              max-width="500px"
              max-height="400Spx"
              class="platform-title-image"
            />
          </v-col>
        </v-row>
        <div class="platform-subtitle-mobile">
          <div class="tway-headline-extra-info grey--text text--darken-3 mt-3">
            22,5% es lo que representa la economía digital en el PIB de Chile
          </div>
          <div class="tway-body grey--text mt-3">
            Fuente: Estudio Accenture Oxford Economics 2018
          </div>
          <div class="btn-subscribe-container">
            <v-btn
              rounded
              color="tway-verde-manzana"
              class="white--text font-weight-bold mt-5"
              :href="config.login"
              x-large
            >
              Inicia sesión
            </v-btn>
          </div>
        </div>
      </v-container>
    </div>
    <div class="tendences">
      <v-container>
        <div class="tway-headline-2 tway-morado--text text-center">
          Tendencias Tecnológicas
        </div>
        <div class="text-center subtitle">
          Efectos estimados de las tendencias tecnológicas en sectores
          seleccionados
        </div>
        <div class="tendencesTable">
          <div class="legend">
            <v-row class="legendRow">
              <v-col :cols="mobile ? 12 : 2">
                <v-row
                  :style="
                    mobile ? 'display:flex ; justify-content: center;' : ''
                  "
                >
                  <div class="cuadrado1"></div>
                  <span>Mayor influencia</span>
                </v-row>
              </v-col>
              <v-col :cols="mobile ? 12 : 2">
                <v-row
                  :style="
                    mobile
                      ? 'display:flex ; justify-content: center;margin-left: 10px;'
                      : ''
                  "
                >
                  <div class="cuadrado2"></div>
                  <span>Influencia moderada</span>
                </v-row>
              </v-col>
              <v-col :cols="mobile ? 12 : 2">
                <v-row
                  :style="
                    mobile
                      ? 'display:flex ; justify-content: center;margin-left: 1px;'
                      : ''
                  "
                >
                  <div class="cuadrado3"></div>
                  <span>Influencia limitada</span>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div class="table" v-if="!mobile">
            <v-row class="headerRow">
              <v-col cols="2" align-self="end">
                <v-row>
                  <span class="headerTitle">
                    Tendencia tecnológica
                  </span>
                </v-row>
              </v-col>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <span class="headerArea">
                      Cuidado de la salud
                    </span>
                  </v-col>
                  <hr style="width:90%;" />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row class="headerIndust">
                      <v-col>
                        <span>Farmacéutica</span>
                      </v-col>
                      <v-col>
                        <span>Salud</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <span class="headerArea">
                      Movilidad
                    </span>
                  </v-col>
                  <hr style="width:90%;" />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row class="headerIndust">
                      <v-col>
                        <span>Transporte y Logística</span>
                      </v-col>
                      <v-col>
                        <span>Automotor</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3">
                <v-row>
                  <v-col cols="12">
                    <span class="headerArea">
                      Industria 4.0
                    </span>
                  </v-col>
                  <hr style="width:95%;" />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row class="headerIndust">
                      <v-col>
                        <span>Industrias avanzadas</span>
                        <v-tooltip bottom max-width="21em">
                          <template v-slot:activator="{ attrs, on }">
                            <v-img
                              style="position: absolute;"
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <span class="text-center">
                            Industrias que aplican tecnologías disruptivas como
                            la fabricación habilitada por Tecnologías de la
                            Información y la mayor capacidad computacional, que
                            prometen ser fábricas inteligentes altamente
                            eficientes y están cada vez más integradas para
                            realizar análisis masivo de datos de manera rápida.
                          </span>
                        </v-tooltip>
                      </v-col>
                      <v-col>
                        <span>Químicos</span>
                      </v-col>
                      <v-col>
                        <span>Electrónica</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2">
                <v-row>
                  <v-col cols="12">
                    <span class="headerArea">
                      Sector habilitador
                    </span>
                  </v-col>
                  <hr style="width:100%;" />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row class="headerIndust">
                      <v-col cols="6">
                        <span>Información</span>
                      </v-col>
                      <v-col cols="6" style="word-wrap: break-word;">
                        <span>Telecomunicaciones</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Automatización de procesos de siguiente nivel
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          Las próximas y potentes automatizaciones llevarán a la
                          reconfiguración de la fuerza laboral como desafío.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Materiales de última generación
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          Estos materiales pueden cambiar la economía de la
                          industria y reconfigurar internamente a las empresas,
                          como la integración de materiales sostenibles e
                          inteligentes, o fuentes de energía renovables.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle3"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      IA aplicada
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          Rama de la Inteligencia Artificial que la saca del
                          mundo de la investigación y se utiliza para tareas en
                          el mundo real, a través de nuevas aplicaciones con
                          ciclos de desarrollo más rápidos y conocimientos cada
                          vez más detallados.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle3"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Futuro de las tecnologías limpias
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          A medida que estas tecnologías bajen la curva de
                          costos, crearán nuevas oportunidades de creación de
                          negocios y programas de mejora operativa impulsados
                          por nuevos mandatos de cambio climático.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Futuro de la conectividad
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          La cobertura mejorada 5G y la velocidad de las
                          conexiones endistancias largas y cortas, permitirán
                          nuevos servicios, modelos comerciales y experiencias
                          para clientes de próxima generación.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Revolución biológica
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          El uso de material biológico con fines informáticos
                          permite el análisis de materiales genéticos y abren
                          posibilidades al desarrollo rápido devacunas, medicina
                          personalizada, terapia genética y una gran expansión
                          del almacenamiento de datos.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Computación de próxima generación
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          Las altas capacidades computacionales permiten nuevos
                          casos de uso, como la simulación a nivel molecular, la
                          disrupción en industrias sobre materiales, medicina,
                          algoritmos de seguridad y difusión rápida de vehículos
                          autónomos.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle3"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Arquitectura de confianza
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          Esta tendencia ayuda a las entidades comerciales y a
                          las personas a establecer confianza y realizar
                          negocios sin necesidad de intermediarios. Las
                          tecnologías de contabilidad distribuida reducirán los
                          costos y permitirán modelos comerciales
                          transformadores.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Infraestructura distribuida
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          Conjunto de equipos que son independientes entre sí y
                          que actúan como una unidad con el fin de la
                          descentralización del procesamiento y el
                          almacenamiento de la información. Podría cambiar la
                          demanda de infraestructura TI en instalaciones y
                          reducir la necesidad de configuración y mantenimiento
                          TI.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <hr style="width:100%;border: 1px solid #D3D3D3;" />
              <v-col cols="12">
                <v-row class="bodyRow">
                  <v-col cols="2" class="d-flex">
                    <div class="rowTitle">
                      Futuro de la programación
                      <v-tooltip right max-width="30em">
                        <template v-slot:activator="{ attrs, on }">
                          <div>
                            <v-img
                              :src="
                                require('@/assets/img/carbon_information.png')
                              "
                              height="15px"
                              width="15px"
                              class="ml-1"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </div>
                        </template>
                        <span class="text-center">
                          A medida que las empresas busquen escalar sus
                          capacidades de desarrollo de software, deberán dominar
                          las prácticas y la tecnología de DataOps y ML Ops para
                          aprovechar al máximo el futuro de la programación.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-row>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="4">
                        <div class="rectangle3"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-row>
                      <v-col cols="6">
                        <div class="rectangle2"></div>
                      </v-col>
                      <v-col cols="6">
                        <div class="rectangle1"></div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div v-if="mobile" class="table">
            <v-carousel
              v-model="currentIndex"
              :show-arrows="false"
              hide-delimiter-background
              height="100%"
              class="pb-10"
            >
              <v-carousel-item v-for="index in 9" :key="index">
                <v-container>
                  <v-row class="headerRow">
                    <v-col cols="7" align-self="end">
                      <v-row>
                        <div class="headerTitle">
                          Tendencia tecnológica
                        </div>
                      </v-row>
                    </v-col>
                    <v-col cols="5">
                      <v-row>
                        <v-col cols="12">
                          <div class="headerArea">
                            {{ carouselData.industry }}
                          </div>
                        </v-col>
                        <hr style="width:90%;" />
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-row class="headerIndust">
                            <v-col>
                              <div>{{ carouselData.area }}</div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Automatización de procesos de siguiente nivel
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            Las próximas y potentes automatizaciones llevarán a
                            la reconfiguración de la fuerza laboral como
                            desafío.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[0]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Materiales de última generación
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            Estos materiales pueden cambiar la economía de la
                            industria y reconfigurar internamente a las
                            empresas, como la integración de materiales
                            sostenibles e inteligentes, o fuentes de energía
                            renovables.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[1]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        IA aplicada
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            Rama de la Inteligencia Artificial que la saca del
                            mundo de la investigación y se utiliza para tareas
                            en el mundo real, a través de nuevas aplicaciones
                            con ciclos de desarrollo más rápidos y conocimientos
                            cada vez más detallados.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[2]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Futuro de las tecnologías limpias
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            A medida que estas tecnologías bajen la curva de
                            costos, crearán nuevas oportunidades de creación de
                            negocios y programas de mejora operativa impulsados
                            por nuevos mandatos de cambio climático.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[3]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Futuro de la conectividad
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            La cobertura mejorada 5G y la velocidad de las
                            conexiones endistancias largas y cortas, permitirán
                            nuevos servicios, modelos comerciales y experiencias
                            para clientes de próxima generación.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[4]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Revolución biológica
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            El uso de material biológico con fines informáticos
                            permite el análisis de materiales genéticos y abren
                            posibilidades al desarrollo rápido devacunas,
                            medicina personalizada, terapia genética y una gran
                            expansión del almacenamiento de datos.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[5]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Computación de próxima generación
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            Las altas capacidades computacionales permiten
                            nuevos casos de uso, como la simulación a nivel
                            molecular, la disrupción en industrias sobre
                            materiales, medicina, algoritmos de seguridad y
                            difusión rápida de vehículos autónomos.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[6]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Arquitectura de confianza
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            Esta tendencia ayuda a las entidades comerciales y a
                            las personas a establecer confianza y realizar
                            negocios sin necesidad de intermediarios. Las
                            tecnologías de contabilidad distribuida reducirán
                            los costos y permitirán modelos comerciales
                            transformadores.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[7]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Infraestructura distribuida
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            Conjunto de equipos que son independientes entre sí
                            y que actúan como una unidad con el fin de la
                            descentralización del procesamiento y el
                            almacenamiento de la información. Podría cambiar la
                            demanda de infraestructura TI en instalaciones y
                            reducir la necesidad de configuración y
                            mantenimiento TI.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[8]"></div>
                    </v-col>
                  </v-row>
                  <hr style="width:100%;border: 1px solid #D3D3D3;" />
                  <v-row class="bodyRow">
                    <v-col cols="6" class="d-flex">
                      <div class="rowTitle">
                        Futuro de la programación
                        <v-tooltip right max-width="30em">
                          <template v-slot:activator="{ attrs, on }">
                            <div>
                              <v-img
                                :src="
                                  require('@/assets/img/carbon_information.png')
                                "
                                height="15px"
                                width="15px"
                                class="ml-1"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </div>
                          </template>
                          <span class="text-center">
                            A medida que las empresas busquen escalar sus
                            capacidades de desarrollo de software, deberán
                            dominar las prácticas y la tecnología de DataOps y
                            ML Ops para aprovechar al máximo el futuro de la
                            programación.
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div :class="carouselData.results[9]"></div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-carousel-item>
            </v-carousel>
          </div>
          <div class="fuente">
            <span
              >Fuente: The top trends in tech; McKinsey analysis, McKinsey &
              Company, 2021.
            </span>
          </div>
        </div>
      </v-container>
    </div>
    <div class="resumen">
      <v-container>
        <div class="tway-headline-2 tway-morado--text text-center">
          Impactamos en empresas de todo tamaño y rubro
        </div>
        <div class="resumen-imagen-desktop py-5">
          <v-img
            :src="require('@/assets/images/tway-services.svg')"
            contain
            max-width="980"
            class="mx-auto"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>
        <div class="resumen-imagen-mobile py-5">
          <v-row>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/icon-shopping-cart.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                COMERCIO
              </div>
            </v-col>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/bulb-on.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                <div>ELECTRICIDAD</div>
                <div>GAS</div>
                <div>AGUA</div>
              </div>
            </v-col>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/earphone-microphone.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                SERVICIOS
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/information.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                INFORMACIÓN y COMUNICACIONES
              </div>
            </v-col>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/icon-home.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                CONSTRUCCIÓN
              </div>
            </v-col>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/diamond-value.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                MINERÍA
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/plane.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                <div>LOGíSTICA</div>
                <div>ALMACENAMIENTO</div>
                <div>TRANSPORTE</div>
              </div>
            </v-col>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/bar-chart-up.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                <div>FINANCIERA</div>
                <div>SEGUROS</div>
              </div>
            </v-col>
            <v-col cols="4">
              <v-img
                :src="require('@/assets/images/cycle.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                <div>AGRíCULTURA</div>
                <div>PESCA</div>
                <div>GANADERÍA</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-img
                :src="require('@/assets/images/cell-phone.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                <div>TECNOLOGÍA</div>
                <div>COMPUTACIÓN</div>
              </div>
            </v-col>
            <v-col cols="6">
              <v-img
                :src="require('@/assets/images/screw.svg')"
                contain
                max-width="80"
                class="mx-auto"
              />
              <div
                class="tway-verde-manzana--text resumen-imagen-servicios-text"
              >
                <div>MANUFACTURA</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>
    <div class="tway-waves tway-waves-bottom tway-waves-grey-2-down"></div>
    <div class="value-proposition tway-grey">
      <v-container>
        <div class="tway-headline-2 tway-morado--text text-center mb-5">
          Las claves de valor de Tway
        </div>
        <v-img
          :src="require('@/assets/images/claves-valor-tway-horizontal.svg')"
          max-width="1350"
          max-height="390"
          contain
          class="claves-valor-tway-horizontal mx-auto"
        />
        <v-img
          :src="require('@/assets/images/claves-valor-tway-vertical.svg')"
          contain
          class="claves-valor-tway-vertical mx-auto"
        />
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {},
      currentIndex: 0,
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
    carouselData() {
      switch (this.currentIndex) {
        case 0:
          return {
            industry: 'Cuidado de la salud',
            area: 'Farmacéutica',
            results: [
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle3',
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
            ],
          }
        case 1:
          return {
            industry: 'Cuidado de la salud',
            area: 'Salud',
            results: [
              'rectangle2',
              'rectangle2',
              'rectangle3',
              'rectangle2',
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle1',
              'rectangle2',
              'rectangle2',
            ],
          }
        case 2:
          return {
            industry: 'Movilidad',
            area: 'Transporte y Logística',
            results: [
              'rectangle1',
              'rectangle3',
              'rectangle2',
              'rectangle3',
              'rectangle1',
              'rectangle1',
              'rectangle1',
              'rectangle1',
              'rectangle1',
              'rectangle1',
            ],
          }
        case 3:
          return {
            industry: 'Movilidad',
            area: 'Automotor',
            results: [
              'rectangle1',
              'rectangle2',
              'rectangle3',
              'rectangle2',
              'rectangle1',
              'rectangle3',
              'rectangle3',
              'rectangle1',
              'rectangle1',
              'rectangle1',
            ],
          }
        case 4:
          return {
            industry: 'Industria 4.0',
            area: 'Industrias avanzadas',
            results: [
              'rectangle1',
              'rectangle1',
              'rectangle3',
              'rectangle1',
              'rectangle1',
              'rectangle1',
              'rectangle3',
              'rectangle1',
              'rectangle1',
              'rectangle3',
            ],
          }
        case 5:
          return {
            industry: 'Industria 4.0',
            area: 'Químicos',
            results: [
              'rectangle1',
              'rectangle2',
              'rectangle3',
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
            ],
          }
        case 6:
          return {
            industry: 'Industria 4.0',
            area: 'Electrónica',
            results: [
              'rectangle1',
              'rectangle1',
              'rectangle3',
              'rectangle3',
              'rectangle2',
              'rectangle2',
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle3',
            ],
          }
        case 7:
          return {
            industry: 'Sector habilitador',
            area: 'Información',
            results: [
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle2',
            ],
          }
        case 8:
          return {
            industry: 'Sector habilitador',
            area: 'Telecomunicaciones',
            results: [
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle1',
              'rectangle1',
              'rectangle1',
              'rectangle1',
              'rectangle1',
            ],
          }
        default:
          return {
            industry: 'Cuidado de la salud',
            area: 'Farmacéutica',
            results: [
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle3',
              'rectangle1',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
              'rectangle2',
            ],
          }
      }
    },
  },
  created: function() {
    this.config.login = process.env.VUE_APP_LOGIN
    this.config.signup = process.env.VUE_APP_SIGNUP
  },
}
</script>

<style lang="scss">
@import '../scss/mixins';

.v-carousel__controls__item {
  color: #b98cea !important;
}

.tendences {
  .subtitle {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #333333;
  }

  .tendencesTable {
    margin-top: 20px;

    .legend {
      .legendRow {
        @include mobile() {
          display: flex;
          justify-content: center;
        }

        @include desktop() {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .cuadrado1 {
        width: 24px;
        height: 24px;
        background: #85bd8d;
        margin-right: 10px;
      }

      .cuadrado2 {
        width: 24px;
        height: 24px;
        background: #cab0ff;
        margin-right: 10px;
      }

      .cuadrado3 {
        width: 24px;
        height: 24px;
        background: #e6e6e6;
        margin-right: 10px;
      }
    }

    .table {
      .headerRow {
        display: flex;
        justify-content: center;
        align-items: flex-start;

        .headerTitle {
          @include mobile() {
            font-family: 'Roboto Condensed';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            display: flex;
            align-items: center;
            color: #333333;
          }

          @include desktop() {
            font-family: 'Roboto Condensed';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            display: flex;
            align-items: center;
            color: #333333;
          }
        }

        .headerArea {
          font-family: 'Roboto Condensed';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          display: flex;
          align-items: center;
          color: #333333;
        }

        .headerIndust {
          font-family: 'Roboto Condensed';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          color: #666666;
        }
      }

      .bodyRow {
        display: flex;
        justify-content: center;
        align-items: center;

        .rectangle1 {
          width: 100%;
          height: 25px;
          background: #85bd8d;
        }

        .rectangle2 {
          width: 100%;
          height: 25px;
          background: #cab0ff;
        }

        .rectangle3 {
          width: 100%;
          height: 25px;
          background: #e6e6e6;
        }

        .rowTitle {
          font-family: 'Roboto Condensed';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          display: flex;
          align-items: center;
          color: #666666;
        }
      }
    }

    .fuente {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Roboto Condensed';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #666666;
      text-align: center;
    }
  }
}

.intro-platform {
  padding-top: 100px;
  padding-bottom: 50px;
  margin-bottom: 50px;
}

.value-proposition {
  padding-top: 100px;
  padding-bottom: 100px;
}

.parameters {
  background-image: url('~@/assets/images/bg/bg-parameters.jpeg');
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 150px;
  padding-bottom: 100px;
}

.tech-partner {
  padding-top: 100px;
  padding-bottom: 100px;
}

.rounded-image {
  border-radius: 5px;
}

.claves-valor-tway-horizontal {
  display: block;
}

.claves-valor-tway-vertical {
  display: none;
}

.btn-subscribe-container {
  text-align: right;
}

.platform-subtitle-no-mobile {
  display: block;
}

.platform-subtitle-mobile {
  display: none;
}

.platform-title-image {
  margin-left: 40px;
  margin-right: 0px;
}

.resumen {
  padding-bottom: 50px;
  margin-top: 150px;
  text-align: center;
}

.resumen-imagen-desktop {
  display: block;
}

.resumen-imagen-mobile {
  display: none;
}

@media (max-width: 960px) {
  .parameters-container {
    height: 100%;
  }

  .parameters-col-text {
    text-align: center;
  }

  .claves-valor-tway-horizontal {
    display: none;
  }

  .resumen-imagen-desktop {
    display: none;
  }

  .resumen-imagen-mobile {
    display: block;
  }

  .claves-valor-tway-vertical {
    display: block;
  }

  .btn-subscribe-container {
    text-align: center;
  }

  .platform-subtitle-no-mobile {
    display: none;
  }

  .platform-subtitle-mobile {
    display: block;
    text-align: center;
  }

  .platform-title-image {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
